/**
 * Gets alignment className for a column
 *
 * @param {string} [align] - Column alignment ('left', 'center', 'right')
 * @returns {string} Tailwind className for text alignment
 *
 * @example
 * getAlignmentClass('right') // Returns: 'text-right'
 * getAlignmentClass() // Returns: 'text-left'
 */
export const getAlignmentClass = (align?: 'left' | 'center' | 'right'): string => {
  return `text-${align ?? 'left'}`;
};
